{
  "labels": {
    "textSingleLine": "文字 - 單行",
    "textMultipleLines": "文字 - 多行",
    "date": "日期",
    "trueFalse": "是/否",
    "singleDocument": "單一文件",
    "multiDocument": "多份文件",
    "number": "數字",
    "eMail": "電子郵件",
    "phone": "電話",
    "dropDownSingleSelectList": "下拉式單選清單",
    "dropDownMultiSelectList": "下拉式多選清單",
    "comboBox": "組合方塊",
    "timestamp": "時間戳記",
    "featureLink": "功能連結"
  },
  "descriptions": {
    "openTextFieldSingleLine": "開放式文字欄位，單行",
    "openTextFieldMultipleLines": "開放式文字欄位，多行",
    "formatMmDdYyyy": "格式 MM/DD/YYYY",
    "toggleButton": "切換按鈕",
    "singleFileUploadField": "單一檔案上傳欄位",
    "multipleFileUploadField": "多個檔案上傳欄位",
    "numericInputField": "數字輸入欄位",
    "emailAddressInputField": "電子郵件地址輸入欄位",
    "format1XxxXxxXxxx": "格式 +1(XXX) XXX-XXXX",
    "selectOneOptionFromAList": "從清單中選擇一個選項",
    "selectMultipleOptionsFromAList": "從清單中選擇多個選項",
    "singleOptionDropDownListOpenTextField": "單選下拉式清單 + 開放式文字欄位",
    "dateAndTimeFields": "日期與時間欄位",
    "linkToTheFormFeatures": "連結至表單功能"
  }
}
